import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { axiosInstance } from "../client";
import { Recourse } from "@rumble-it/common-lib/types/models/Recourse.interface";

export const fetchRecourses = async (): Promise<CollectionResponse<Recourse>> =>
  axiosInstance.get(`/admin/recourses`).then((response) => response.data);
